import { buildDateTime } from "utils/dateHelper";
import { absTimeDifference } from "utils/timeDifference";

export const columns = [
    {
        id: "staffName",
        Header: "Name",
        accessor: (row) => row.fullName,
        sortable: true,
        filterable: true,
    },
    {
        id: "staffRole",
        Header: "Role",
        accessor: (row) => row.role.name,
        sortable: true,
        filterable: true,
    },
    {
        id: "Action",
        Header: "View",
        accessor: "actions",
        sortable: false,
        filterable: false,
    },
];

export const eventTypes = {
    ATTENDANCE: "Attendance",
    STAFF_APPLICATION: "Staff Application",
};

export const colorMap = {
    COMPLETED: { name: "green", code: "#2dce89" },
    HALF_COMPLETED: { name: "red", code: "#ffd600" },
    UNATTENDED: { name: "default" },
};

export const colorLogic = (event) => {
    if (event.arrivalTime && event.leavingTime) return colorMap.COMPLETED.name;
    if (event.arrivalTime) return colorMap.HALF_COMPLETED.name;
    return "default";
};

export const eventColors = (event, start, end, isSelected) => {
    return { className: `event-${colorLogic(event)}` };
};

export const transformAttendance = (events) =>
    events.map((event) => {
        const start = buildDateTime(
            event.date,
            String(event.arrivalTime).slice(0, 8)
        );
        const end = event.leavingTime
            ? buildDateTime(event.date, String(event.leavingTime).slice(0, 8))
            : start;
        return {
            ...event,
            start,
            end,
            title:
                event?.arrivalTime && event?.leavingTime
                    ? "Tapped In & Out"
                    : "Tapped In",
            eventType: eventTypes.ATTENDANCE,
        };
    });

export const transformLeaves = (events) =>
    events.map((event) => {
        const eventDate = buildDateTime(event.date);
        return {
            ...event,
            start: eventDate,
            end: eventDate,
            title: `${event.isOt ? "OT" : event.type} (${
                event.isOt
                    ? (
                          absTimeDifference(event.startTime, event.endTime) / 60
                      ).toFixed(2) + "h"
                    : event.period === "HD"
                    ? event.amPm
                    : event.period
            }) ${event.deleted ? "Deleted" : ""} ${
                event.approved ? "[Approved]" : "[Pending]"
            }`,
            eventType: eventTypes.STAFF_APPLICATION,
        };
    });

export const mergeEvents = (attendance, leaves, ot) =>
    (attendance && leaves && ot && [...attendance, ...leaves, ...ot]) || [];
